import React from 'react';
import { useTranslation } from 'react-i18next';

import classes from './styles.module.scss';

import Tick from '../../../assets/icon-tick.svg?react';

interface Props {
    inclusions: string[];
}

export default function Inclusions({ inclusions }: Props) {
    const { t } = useTranslation();

    return (
        <>
            <span className={`${classes.descriptionsInclusions}`}>
                {t('stack:inclusions')}
            </span>
            <div className={`${classes.description}`}>
                {inclusions &&
                    inclusions.slice(0, 4).map((text, index) => (
                        <div className={classes.inclusion} key={`${index}_inclusion_idx`}>
                            <span className={classes.tick}>
                                <Tick />
                            </span>
                            <span className={classes.text}>{text}</span>
                        </div>
                    ))}
            </div>
        </>
    );
}
